import Loadable from 'pages/SwVersions/Loadable';
import reducer from './modules/swVersions.slice';

export default {
	component: Loadable,
	reducer
};